
import styled from '@emotion/styled';

export const RaceLabelWrapper = styled('div', { label: 'RaceLabelWrapper' })`
    display: flex;
    align-items: center;
`;
